<template>
  <div>
    <b-row style="height:calc(100vh - 200px);overflow-y:auto;" class="m-0">
      <b-col cols="4">
        <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
          <template v-slot:header>
            <h6 class="mb-0">Details</h6>
          </template>
          <b-card-text>
            <span>Overall Score:</span>
            <span class="float-right">
              <b-badge variant="danger">HIGH</b-badge>
            </span>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Country:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">LOW</b-badge>
            </span>
            <br />
            <b-progress value="20" show-progress class="mb-2 mt-2" variant="success"></b-progress>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Industry:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">MEDIUM</b-badge>
            </span>
            <br />
            <b-progress value="35" show-progress class="mb-2 mt-2" variant="warning"></b-progress>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Negative Media:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">LOW</b-badge>
            </span>
            <br />
            <b-progress value="75" show-progress class="mb-2 mt-2" variant="danger"></b-progress>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Sanctions and enforecments:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">LOW</b-badge>
            </span>
            <br />
            <b-progress value="0" show-progress class="mb-2 mt-2" variant="primary"></b-progress>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Deal Size:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">High</b-badge>
            </span>
            <br />
            <b-progress value="80" show-progress class="mb-2 mt-2" variant="danger"></b-progress>
          </b-card-text>
          <b-card-text>
            <span>
              <strong>Longevity:</strong>
            </span>
            <span class="float-right">
              <b-badge variant="success">LOW</b-badge>
            </span>
            <br />
            <b-progress value="10" show-progress class="mb-2 mt-2" variant="primary"></b-progress>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="8">
        <b-row style="height:calc(100vh - 200px);overflow-y:auto;" class="m-0">
          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Country</h6>
              </template>
              <b-card-text class="mb-2">
                <span>
                  <strong>Weight:</strong>
                </span>
                <span class="ml-2">30%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Calcualted Score</strong>
                </span>
                <span class="ml-2">25%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Overall Score</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="warning">LOW</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Country:</strong>
                </span>
                <span class="ml-2">Spain</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>CPI Index:</strong>
                </span>
                <span class="ml-2">33</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Active Sanctions:</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="danger">YES</b-badge>
                </span>
              </b-card-text>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Sanctions and enforecments</h6>
              </template>

              <b-card-text class="mb-2">
                <span>
                  <strong>Weight:</strong>
                </span>
                <span class="ml-2">30%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Calcualted Score</strong>
                </span>
                <span class="ml-2">25%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Overall Score</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="warning">LOW</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>No of alerts:</strong>
                </span>
                <span class="ml-2">20</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Sanction Hit:</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="danger">YES</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Enforcement Hit:</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="danger">YES</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>No of Positive Alerts</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="danger">5</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>No of Negative Alerts</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="success">3</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Predictive Remediation Match</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="danger">Positive Match</b-badge>
                </span>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Negative Media</h6>
              </template>

              <b-card-text class="mb-2">
                <span>
                  <strong>Weight</strong>
                </span>
                <span class="ml-2">25%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Calcualted Score</strong>
                </span>
                <span class="ml-2">25%</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Overall Score</strong>
                </span>
                <span class="ml-2">
                  <b-badge variant="warning">LOW</b-badge>
                </span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Number of matched articles</strong>
                </span>
                <span class="ml-2">5</span>
              </b-card-text>
              <b-card-text class="mb-2">
                <span>
                  <strong>Matched Keyword Count</strong>
                </span>
                <span class="ml-2">
                  <br />Bribery
                  <b-badge variant="primary">5</b-badge>
                  <br />Corruption
                  <b-badge variant="primary">5</b-badge>
                  <br />Fined
                  <b-badge variant="primary">5</b-badge>
                  <br />Charged
                  <b-badge variant="primary">5</b-badge>
                  <br />
                </span>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Industry</h6>
              </template>

              <b-card-text>
                <span>
                  <strong>Industry:</strong>
                </span>
                <span class="float-right">
                  <b-badge variant="success">LOW</b-badge>
                </span>
                <br />
                <b-progress value="45" show-progress class="mb-2 mt-2" variant="success"></b-progress>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Deal Size</h6>
              </template>

              <b-card-text>
                <span>
                  <strong>Deal Size:</strong>
                </span>
                <span class="float-right">
                  <b-badge variant="success">LOW</b-badge>
                </span>
                <br />
                <b-progress value="45" show-progress class="mb-2 mt-2" variant="success"></b-progress>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card header-tag="header" class="m-2 text-left" v-if="!isLoading">
              <template v-slot:header>
                <h6 class="mb-0">Longeiity</h6>
              </template>

              <b-card-text>
                <span>
                  <strong>Longevity:</strong>
                </span>
                <span class="float-right">
                  <b-badge variant="success">LOW</b-badge>
                </span>
                <br />
                <b-progress value="45" show-progress class="mb-2 mt-2" variant="success"></b-progress>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "CalculationComponent",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
  props: {
    isLoading: Boolean
  }
};
</script>